import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface FieldConfig {
  // Device info columns
  organization?: boolean;
  id?: boolean;
  name?: boolean;
  type?: boolean;
  
  // Status columns
  support_status?: boolean;
  etiquetas?: boolean;
  
  // Battery columns
  battery_soc?: boolean;
  battery_soc_slope?: boolean;
  battery_soc_remain_days?: boolean;
  type_battery?: boolean;
  
  // Connectivity columns
  operator_mobil?: boolean;
  connectivity?: boolean;
  sim_mega?: boolean;
  
  // Other indicators
  last_metric_date?: boolean;
  ratio_buffer?: boolean;
  ratio_outlier?: boolean;
  dga_active?: boolean;
  events_count?: boolean;
}

interface DevicesSupportState {
  showMenuSupport: boolean;
  showFilterConfig: boolean;
  showFilterAdvance: boolean;
  showFieldsConfig: boolean;
  fieldConfig: FieldConfig;
}

const initialState: DevicesSupportState = {
  showMenuSupport: false,
  showFilterConfig: false,
  showFilterAdvance: false,
  showFieldsConfig: false,
  fieldConfig: {},
};

const { reducer, actions } = createSlice({
  name: 'devices_support_store',
  initialState,
  reducers: {
    setShowMenuSupport(state: DevicesSupportState, action: PayloadAction<boolean>): void {
      state.showMenuSupport = action.payload;
    },
    setShowFilterConfig(state: DevicesSupportState, action: PayloadAction<boolean>): void {
      state.showFilterConfig = action.payload;
      if (action.payload) state.showMenuSupport = false;
    },
    setShowFilterAdvance(state: DevicesSupportState, action: PayloadAction<boolean>): void {
      state.showFilterAdvance = action.payload;
      if (action.payload) state.showMenuSupport = false;
    },
    setShowFieldsConfig(state: DevicesSupportState, action: PayloadAction<boolean>): void {
      state.showFieldsConfig = action.payload;
      if (action.payload) state.showMenuSupport = false;
    },
    setFieldConfig(state: DevicesSupportState, action: PayloadAction<FieldConfig>): void {
      state.fieldConfig = action.payload;
    },
  },
});

export default reducer;

export const {
  setShowMenuSupport,
  setShowFilterConfig,
  setShowFilterAdvance,
  setShowFieldsConfig,
  setFieldConfig,
} = actions;
